import { CommitClass } from '../contract/constants.js';
import { immutable } from '../contract/stable.js';
import { validateTransition } from '../contract/transition-log.js';
import { stableSerialize } from '../contract/stable.js';

const nonEmpty = (value) => typeof value === 'string' && value.trim().length > 0;

export function validateCanonicalRecord(input, transition, options = {}) {
  if (!validateTransition(transition, options)) return false;
  if (!input || !nonEmpty(input.canonicalId) || !nonEmpty(input.representation)) return false;
  if (input.sourceTraceId !== transition.traceId) return false;
  if (!Array.isArray(input.sourceEventIds) || JSON.stringify(input.sourceEventIds) !== JSON.stringify(transition.eventIds)) return false;
  if (input.governanceToken !== transition.governanceToken || input.signer !== transition.signer) return false;
  if (stableSerialize(input.predicateVector) !== stableSerialize(transition.predicateVector)) return false;
  if (!Array.isArray(input.provenanceLedger) || input.provenanceLedger.length === 0) return false;
  if (input.committedAt !== transition.timestamp) return false;
  if (input.commitClass && input.commitClass !== CommitClass.CANONICAL) return false;
  return true;
}

export function createCanonicalRecord(input, transition, options = {}) {
  if (!validateCanonicalRecord(input, transition, options)) throw new Error('CANONICAL_REQUIRES_VALID_TRANSITION');
  return immutable({
    ...input,
    sourceEventIds: immutable([...input.sourceEventIds]),
    predicateVector: immutable({ ...input.predicateVector }),
    provenanceLedger: immutable([...input.provenanceLedger]),
    commitClass: CommitClass.CANONICAL,
    transitionRecordId: transition.transitionRecordId
  });
}
